/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { showNotification } from 'src/core/helpers'
import styles from './DownloadCsvButton.module.scss'
import { CloudDownloadOutlined } from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  getPurchasesFromCertificates,
  getOrderCertificatesSelector,
  ordersCertificatesSelector,
  canExportOrdersSelector
} from 'src/features'

const DownloadCsvButton = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const validationResponse = useAppSelector(canExportOrdersSelector)
  const certificates = useAppSelector(ordersCertificatesSelector)
  const { loading } = useAppSelector(getOrderCertificatesSelector)

  const handleClick = () => {
    const labels = {
      'EMPTY_ERROR': t('Transactions.NoOrdersSelected'),
      'ONLY_PAID_ERROR': t('Transactions.OnlyPaidError')
    }
    if (validationResponse !== 'SUCCESS') {
      showNotification('error', labels[validationResponse])
      return
    }
    dispatch(getPurchasesFromCertificates(certificates))
  }

  return (
    <Button
      icon={<CloudDownloadOutlined />}
      className={styles['button']}
      loading={loading}
      onClick={handleClick}
    >
      {loading ? t('Transactions.ExportingData') : t('Transactions.ExportSelectedOrders')}
    </Button>
  )
}

export default DownloadCsvButton
